import query from 'component-query';
import page from 'page';

page('*', canonical);

function canonical(ctx, next) {
  if (ctx.init) {
    return next();
  }

  let link = query('link[rel=canonical]');
  if (!link) {
    link = document.createElement('link'); // eslint-disable-line no-undef
  }

  const path = ctx.pathname.split('?')[0];
  const hasSlash = path.charAt(path.length - 1) === '/';

  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', `https://auth0.com${path}${hasSlash ? '' : '/'}`);

  if (!link.parentNode) {
    after(query('title'), link);
  }

  return next();
}

function after(node, element) {
  if (!node.nextSibling) {
    return node.parentNode.appendChild(element);
  }

  return node.parentNode.insertBefore(element, node.nextSibling);
}



// WEBPACK FOOTER //
// ./src/modules/canonical/canonical.js